import enus from './en-us';
import esus from './es-us';
import enca from './en-ca';
import frca from './fr-ca';
import {
  enCA as onexEnCA,
  enUS as onexEnUS,
  esUS as onexEsUS,
  frCA as onexFrCA,
} from '@primerica/onex-ui-lib';

const merged = {
  ...enca,
  ...onexEnCA,
  ...enus,
  ...onexEnUS,
  ...esus,
  ...onexEsUS,
  ...frca,
  ...onexFrCA,
};

export type LocaleKeys = keyof typeof merged;

function generateTranslationKeys(): Record<LocaleKeys, LocaleKeys> {
  // array of all of the i18n keys, e.g.
  //  ['$vuetify', 'onex_accessibility_checkmark', ...]
  const arrayOfKeys = Object.keys(merged) as LocaleKeys[];

  // array of entries like [LocaleKeys, LocaleKeys], e.g.
  //   ['$vuetify', '$vuetify']
  //   ['onex_accessibility_checkmark', 'onex_accessibility_checkmark']
  const arrayOfEntries = arrayOfKeys.map((key) => [key, key] as const);

  return Object.fromEntries(arrayOfEntries) as Record<LocaleKeys, LocaleKeys>;
}

export const Translations = generateTranslationKeys();
